import { createFileRoute } from "@tanstack/react-router";
import { LegacyLinkRedirect } from "@/components/signin/legacy-link";

/**
 * `/login` — заглушка старого SSO (Laravel отдавал по этому пути 401 JSON).
 * У нас экран входа живёт в корне; сюда приходят по старым ссылкам и закладкам.
 */
export const Route = createFileRoute("/login")({
	component: LegacyLinkRedirect,
});
